import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const ChevronUpIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M17.4697 15.5303L12.0001 10.0607L6.53039 15.5303L5.46973 14.4697L12.0001 7.93933L18.5304 14.4697L17.4697 15.5303Z", fill: "currentColor" }));
//# sourceMappingURL=ChevronUpIcon.js.map